/**
 * Edit Controller
 */
(function(angular) {
  'use strict';

  var app = angular.module('asDemandMgr');

	app.controller('CreativeEditController', [
		'$scope',
		'$window',
		'creativeApi',
		'advertiserApi',
		'optionsApi',
		'campaignApi',
		'InterscrollerCommonService', 'InterscrollerTypeAService', 'InterscrollerTypeBService', 'InterscrollerTypeCService', 'InterscrollerTypeEService',
		'InscreenCommonService',		'InscreenTypeAService',
		'SitebarCommonService',		'SitebarTypeAService',
		'HPACommonService',
		'InImageCommonService',		'InImageTypeAService',	'InImageTypeBService',		'InImageTypeCService',		'InImageTypeDService',		'InImageTypeXService',
		function($scope, $window, creativeApi, advertiserApi, optionsApi, campaignApi,
			InterscrollerCommonService, InterscrollerTypeAService, InterscrollerTypeBService, InterscrollerTypeCService, InterscrollerTypeEService,
            InscreenCommonService, InscreenTypeAService,
            SitebarCommonService, SitebarTypeAService,
			HPACommonService,
            InImageCommonService, InImageTypeAService, InImageTypeBService, InImageTypeCService, InImageTypeDService, InImageTypeXService
		) {
			// init values
			$scope.advertiser = {
				fees: [],
				contacts: [],
				iab: '0',
			};

        $scope.now = moment
            .utc()
            .seconds(0)
            .milliseconds(0)
            .valueOf();


      $scope.useCustomStartDate = false;
      $scope.useCustomEndDate = false;
      $scope.start = null;
      $scope.end = null;
      $scope.minStart = $scope.now;
      $scope.maxStart = $scope.now;
      $scope.minEnd = $scope.now;
      $scope.maxEnd = $scope.now;
      $scope.campaignTimezone = "Europe/Berlin";

      $scope.adGapIdMandatory = false;
      $scope.isAdGapIdMandatory = function () {
          return $scope.adGapIdMandatory;
      };


        $scope.validTypePairs = [
            {
                campaign_type: ["interscroller-RTA", "interscroller-non-RTA", "MInskin-RTA", "MInskin-non-RTA"],
                creative_type: ["JS Interscroller Type.*"]
            },
            {
                campaign_type: ["inskin-RTA", "inskin-non-RTA"],
                creative_type: ["JS InSkin"]
            },
            {
                campaign_type: ["inscreen-RTA", "inscreen-non-RTA"],
                creative_type: ["JS InScreen Type.*"]
            },
            {
                campaign_type: ["sitebar-RTA", "sitebar-non-RTA"],
                creative_type: ["JS Sitebar Type.*"]
            },
            {
                campaign_type: ["video-multiscreen"],
                creative_type: ["vastInlineHtml", "vastInlineHtmlWrapper"]
            },
            {
                campaign_type: ["m-interstitial"],
                creative_type: ["interstitial"]
            },
            {
                campaign_type: ["m-native"],
                creative_type: ["native"]
            },
            {
                campaign_type: ["hpa-RTA", "hpa-non-RTA"],
                creative_type: ["JS HPA Type.*"]
            },
            {
                campaign_type: ["InImage non-RTA"],
                creative_type: ["InImage Type.*"]
            },

        ];
        $scope.isInvalidTypesDetected = false;
        $scope.click_url_warn = '';

        $scope.creative = {
            active: true,
            weight: 1,
            _advertiserId: null,
            _campaignId: null,
            type: null,
            adgap_id: '',
            adgap_share_imps: false,
            adgap_share_clicks: false,
            content: '',
            switch_in_min_suggested_duration_seconds: 10,
            trackingPxl: [],
            vtrStart: [],
            vtrFirstQuartile: [],
            vtrMidpoint: [],
            vtrThirdQuartile: [],
            vtrComplete: [],
            isInstanceUpdated: false,
            microsite: '',
            amediaUrl: '',
            assets: {
                1:[],
                2:[],
                3:[],
                4:[]
            }
      };

      $scope.log = {
        count: 0,
        data: [],
      };
      $scope.sspx_redirector = {
          code: ''
      };
      $scope.vastAdTagUriValidation = {
          isLoading: false,
          msg: ''
      };

      $scope.interscrollerTypes = [
          'JS Interscroller Type A',
          'JS Interscroller Type B',
          'JS Interscroller Type C',
          'JS Interscroller Type E',
      ];
        
        $scope.inscreenTypes = [
            'JS InScreen Type A',
        ];

        $scope.sitebarTypes = [
            'JS Sitebar Type A',
        ];

			$scope.HPATypes = [
				'JS HPA Type H',
			];
			$scope.InImageTypes = [
				'InImage Type A',
				'InImage Type B',
				'InImage Type C',
				'InImage Type D',
				'InImage Type X',
			];

      $scope.instlTypes = [
          {name: "HTML", value: 1},
          {name: "Upload ZIP", value: 2},
          {name: "External Link", value: 3},
      ];

      $scope.options = {};

      $scope.creativeProperties = null;

      $scope.campaign = {};

      $scope.loadedCreativeType = null;





      // load campaign from server
      if (window.campaignId) {
          campaignApi.read(window.campaignId).then(
              function(data) {
                  $scope.campaign = data.campaign;
                  $scope.creative._campaignId = window.campaignId;
                  $scope.adGapIdMandatory = data.agency.has_adgap;
                  if (typeof $scope.campaign.timezone !== 'undefined' && $scope.campaign.timezone) {
                      $scope.campaignTimezone = $scope.campaign.timezone;
                  }


                  $scope.minStart = $scope.campaign.start;
                  $scope.minEnd = $scope.campaign.start;
                  $scope.maxStart = $scope.campaign.end;
                  $scope.maxEnd = $scope.campaign.end;
                  $scope.start = $scope.campaign.start;
                  $scope.end = $scope.campaign.end;
              },
              function() {
                  console.log('could not load campaign');
              }
          );
      }


        // reset all assets on creative type change
      $scope.changeType = function(type) {
        $scope.creative.image = null;
        $scope.creative.tmpImage = null;
        $scope.creative.video = null;
        $scope.creative.tmpVideo = null;
        $scope.creative.tmpAmediaZip = null;
      };



      // load creative from server
      if (!window.creativeId) {
        // for new creatives inherit advertiser and agency from client selection if set

        if (!window.creativeId && window.advertiserId) {
          $scope.creative._advertiserId = window.advertiserId;
        }
        if (!window.creativeId && window.campaignId) {
            $scope.creative._campaignId = window.campaignId;
        }
      }

      function setUpStartEnd() {
          if ($scope.creative.start !== null) {
              $scope.useCustomStartDate = true;
              $scope.start = $scope.creative.start;
          }
          if ($scope.creative.end !== null) {
              $scope.useCustomEndDate = true;
              $scope.end = $scope.creative.end;
          }
      }

        $scope.$watch('useCustomStartDate',function(newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.creative.start = newVal && $scope.start !== $scope.campaign.start ? $scope.start : null;
            }
        },true);
        $scope.$watch('useCustomEndDate',function(newVal, oldVal) {
            if (newVal != oldVal) {
                $scope.creative.end = newVal && $scope.start !== $scope.campaign.start ? $scope.end : null;
            }
        },true);
        $scope.$watch('start',function(newVal, oldVal) {
                if ($scope.useCustomStartDate && newVal != oldVal) {
                    $scope.creative.start = newVal === $scope.campaign.start ? null : newVal;
                }
            },true);
        $scope.$watch('end',function(newVal, oldVal) {
            if ($scope.useCustomEndDate && newVal != oldVal) {
                $scope.creative.end = newVal === $scope.campaign.end ? null : newVal;
            }
        },true);

        $scope.fetch = function(){
          if (window.creativeId) {
              creativeApi.read(window.creativeId).then(
                  function (data) {
                      $scope.creative = data.creative;
                      setUpStartEnd();

                      $scope.loadedCreativeType = $scope.creative.type;

                      if ($scope.creative.type == 'JS Interscroller Type A' && $scope.creative.interscrollerOptions == null){
                          $scope.creative.interscrollerOptions =  Object.assign({}, InterscrollerTypeAService.getDefaultOptions());
                      }
                      if ($scope.creative.type == 'JS Interscroller Type B' && $scope.creative.interscrollerOptions == null){
                          $scope.creative.interscrollerOptions = Object.assign({}, InterscrollerTypeBService.getDefaultOptions());
                      }
                      if ($scope.creative.type == 'JS Interscroller Type C' && $scope.creative.interscrollerOptions == null){
                          $scope.creative.interscrollerOptions = Object.assign({}, InterscrollerTypeCService.getDefaultOptions());
                      }
                      if ($scope.creative.type == 'JS Interscroller Type E' && $scope.creative.interscrollerOptions == null){
                          $scope.creative.interscrollerOptions = Object.assign({}, InterscrollerTypeEService.getDefaultOptions());
                      }
                      if ($scope.creative.type == 'JS Interscroller Type Z' && $scope.creative.interscrollerOptions == null){
                          // $scope.creative.interscrollerOptions = Object.assign({}, $scope.defaultInterscrollerTypeCOptions);
                      }

                      // inscreen
                      if ($scope.creative.type === 'JS InScreen Type A' && $scope.creative.inscreenOptions == null){
                          $scope.creative.inscreenOptions = Object.assign({}, InscreenTypeAService.getDefaultOptions());
                      }

                      // sitebar
                      if ($scope.creative.type === 'JS Sitebar Type A' && $scope.creative.sitebarOptions == null){
                          $scope.creative.sitebarOptions = Object.assign({}, SitebarTypeAService.getDefaultOptions());
                      }

							// inimage
							if ($scope.creative.type === 'InImage Type A' && $scope.creative.inimageOptions == null) {
								$scope.creative.inimageOptions = Object.assign({}, InImageTypeAService.getDefaultOptions());
							}
							if ($scope.creative.type === 'InImage Type B' && $scope.creative.inimageOptions == null) {
								$scope.creative.inimageOptions = Object.assign({}, InImageTypeBService.getDefaultOptions());
							}
							if ($scope.creative.type === 'InImage Type C' && $scope.creative.inimageOptions == null) {
								$scope.creative.inimageOptions = Object.assign({}, InImageTypeCService.getDefaultOptions());
							}
							if ($scope.creative.type === 'InImage Type D' && $scope.creative.inimageOptions == null) {
								$scope.creative.inimageOptions = Object.assign({}, InImageTypeDService.getDefaultOptions());
							}
							if ($scope.creative.type === 'InImage Type X' && $scope.creative.inimageOptions == null) {
								$scope.creative.inimageOptions = Object.assign({}, InImageTypeXService.getDefaultOptions());
							}

							$scope.log = data.log;
						},
						function() {
							console.error('could not load creative');
						}
					);
				}
			};

      // get advertisers
      advertiserApi
        .getList(
          { field: 'name', order: 'asc' },
          '',
          { number: 0, size: -1 }
        )
        .then(
          function(advertisers) {
            $scope.advertisers = [];

            advertisers.data.forEach(function(advertiser) {
              $scope.advertisers.push({
                name: advertiser.name,
                value: advertiser._id,
              });
            });
          },
          function() {
            console.error('could not load advertisers');
          }
        );

      $scope.$watch('creative.tmpImage', function(newVal) {
        if (newVal) {
          $scope.creative.image = null;
        }
      });


      $scope.checkCLICK_URL = function(content) {
          if (content && (
              (content.indexOf("[CLICK_URL]") == -1 && content.indexOf("[CLICK_TRACKING_URL]") == -1)
          )){
              if (!window.confirm("Missing macro, [CLICK_URL] or [CLICK_TRACKING_URL]. Should the creative be saved though?")){
                  return false;
              }
          }
          return true;
      }
     $scope.checkEXTRA_TRACKING_IMGS = function(content) {
        if (content && content.indexOf("[EXTRA_TRACKING_IMGS]") == -1){
            alert("Missing macro [EXTRA_TRACKING_IMGS]!");
            return false;
        }
        return true;
     }

     $scope.$watch('creative.click_url', function(newValue, oldValue) {
         let maxLen = 512;
         $scope.click_url_warn = '';
            if (newValue && newValue.length > maxLen) {
                $scope.click_url_warn = 'Max length should be less than '+maxLen+'. Now: ' + newValue.length;
            }
     });

      // try saving and process server side validation errors
      $scope.submitForm = function() {


          if ($scope.adGapIdMandatory && !$scope.creative.adgap_id){
              if (!window.confirm("Missing AdGap ID. Are you sure you want to continue saving?")){
                  return;
              }
          }


        if ($scope.creative.type === 'JS Sitebar Type H' || $scope.creative.type === 'JS HPA Type H' ||
            ['InImage Type A', 'InImage Type B', 'InImage Type C', 'InImage Type D'].includes($scope.creative.type)
        ) {
            if (!$scope.checkCLICK_URL($scope.creative.content)) {
                return;
            }
            if (!$scope.checkEXTRA_TRACKING_IMGS($scope.creative.content)) {
                return;
            }
        }
          if ($scope.creative.type === 'interstitial' && $scope.creative.instl_type == 1) {
              if (!$scope.checkCLICK_URL($scope.creative.instl_content)) {
                  return;
              }
              if (!$scope.checkEXTRA_TRACKING_IMGS($scope.creative.instl_content)) {
                  return;
              }
          }


        if ($scope.creative.type === 'rawHTML' ||
            $scope.creative.type === 'rawJS' ||
            $scope.creative.type === 'JS InSkin' ||
            $scope.creative.type === 'JS Interscroller Type A' ||
            $scope.creative.type === 'JS Interscroller Type B' ||
            $scope.creative.type === 'JS Interscroller Type C' ||
            $scope.creative.type === 'JS Interscroller Type E' ||
            $scope.creative.type === 'JS InScreen Type A' ||
            $scope.creative.type === 'JS Sitebar Type A'
        )
        {
          if ($scope.creative.content && $scope.creative.content.indexOf("[IMPRESSION_JS_CODE]") === -1 &&
              $scope.creative.content.indexOf("[IMPRESSION_HTML_CODE]") == -1 &&
              $scope.creative.content.indexOf("[IMPRESSION_URL]") == -1
          ){
            if (!window.confirm("You don't have any impression macroses([IMPRESSION_JS_CODE] or [IMPRESSION_HTML_CODE] or [IMPRESSION_URL]) in the Content field. Are you sure you want to continue saving?")){
              return;
            }
          }

            if ($scope.creative.content && $scope.creative.content.indexOf("[CLICK_URL]") == -1 &&
                 $scope.creative.content.indexOf("[CLICK_TRACKING_URL]") == -1){
                if (!window.confirm("You don't have click macros([CLICK_URL]) in the Content field. Are you sure you want to continue saving?")){
                    return;
                }
            }

            if ($scope.creative.content) {
                creativeApi.checkContent($scope.creative.type, $scope.creative.content).then(
                    function (checkResults) {
                        if (!checkResults.success) {
                            if (!window.confirm(checkResults.message)) {
                                return;
                            }
                        }
                    });
            }



            switch ($scope.creative.type) {
                case 'JS Interscroller Type A':
                    $scope.creative.content = InterscrollerTypeAService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                    $scope.creative.content += $scope.creative.interscrollerOptions.rawJsAppendix;
                    break;
                case 'JS Interscroller Type B':
                    $scope.creative.content = InterscrollerTypeBService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                    $scope.creative.content += $scope.creative.interscrollerOptions.rawJsAppendix;
                    break;
                case 'JS Interscroller Type C':
                    $scope.creative.content = InterscrollerTypeCService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                    $scope.creative.content += $scope.creative.interscrollerOptions.rawJsAppendix;
                    break;
                case 'JS Interscroller Type E':
                    $scope.creative.content = InterscrollerTypeEService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                    $scope.creative.content += $scope.creative.interscrollerOptions.rawJsAppendix;
                    break;

                case 'JS Interscroller Type Z':
                    break;

                case 'JS InScreen Type A':
                    $scope.creative.content = InscreenTypeAService.generateContent($scope, InscreenCommonService, $scope.creative.inscreenOptions);
                    $scope.creative.content += $scope.creative.inscreenOptions.rawJsAppendix;
                    break;

                case 'JS Sitebar Type A':
                    $scope.creative.content = SitebarTypeAService.generateContent($scope, SitebarCommonService, $scope.creative.sitebarOptions);
                    $scope.creative.content += $scope.creative.sitebarOptions.rawJsAppendix;
                    break;
            }
        }

        creativeApi.save($scope.creative).then(
          function() {
              if ($scope.creative._campaignId) {
                  $window.location.href = '/#!/demandmgr/campaign/edit?id=' + $scope.creative._campaignId;
              } else {
                  $window.location.href = '/#!/demandmgr/creative';
              }
          },
          function(data) {
              defaultSaveErrorHandler($scope.creativeForm, data);
          }
        );
      };

      $scope.addslashes = function(string) {
            if (!string) return string;
            return string.replace(/\\/g, '\\\\').
            replace(/\u0008/g, '\\b').
            replace(/\t/g, '\\t').
            replace(/\n/g, '\\n').
            replace(/\f/g, '\\f').
            replace(/\r/g, '\\r').
            replace(/'/g, '\\\'').
            replace(/"/g, '\\"').
            replace(/<script/g, '<scr"+"ipt').
            replace(/<\/script/g, '</scr"+"ipt').
            replace(/<SCRIPT/g, '<SCR"+"IPT').
            replace(/<\/SCRIPT/g, '</SCR"+"IPT');

      };





        function addInterscrollerOptionsWatch() {
            console.log('Add watch');
            $scope.$watch('creative.interscrollerOptions', function(newValue, oldValue) {
                console.log('on creative.interscrollerOption', newValue, oldValue);
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && newValue && oldValue && newValue.rawJsAppendix === oldValue.rawJsAppendix)
                {
                    console.log('Gen content if needed');
                    switch ($scope.creative.type) {
                        case "JS Interscroller Type A":
                            $scope.creative.content = InterscrollerTypeAService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                            break;
                        case "JS Interscroller Type B":
                            $scope.creative.content = InterscrollerTypeBService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                            break;
                        case "JS Interscroller Type C":
                            $scope.creative.content = InterscrollerTypeCService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                            break;
                        case "JS Interscroller Type E":
                            $scope.creative.content = InterscrollerTypeEService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                            break;
                        case "JS Interscroller Type Z":
                            //$scope.genInterscollerTypeZContent();
                            break;
                    }
                }
            }, true);
        }

        function addInscreenOptionsWatch() {
            console.log('Add watch');
            $scope.$watch('creative.inscreenOptions', function(newValue, oldValue) {
                console.log('on creative.inscreenOptions', newValue, oldValue);
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && newValue && oldValue && newValue.rawJsAppendix === oldValue.rawJsAppendix)
                {
                    console.log('Gen content if needed');
                    switch ($scope.creative.type) {
                        case "JS InScreen Type A":
                            $scope.creative.content = InscreenTypeAService.generateContent($scope, InscreenCommonService, $scope.creative.inscreenOptions);
                            break;
                    }
                }
            }, true);
        }

        function addSitebarOptionsWatch() {
            console.log('Add watch');
            $scope.$watch('creative.sitebarOptions', function(newValue, oldValue) {
                console.log('on creative.sitebarOptions', newValue, oldValue);
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && newValue && oldValue && newValue.rawJsAppendix === oldValue.rawJsAppendix)
                {
                    console.log('Gen content if needed');
                    switch ($scope.creative.type) {
                        case "JS Sitebar Type A":
                            $scope.creative.content = SitebarTypeAService.generateContent($scope, SitebarCommonService, $scope.creative.sitebarOptions);
                            break;
                    }
                }
            }, true);
        }

        $scope.$watch('creative.VASTAdTagURI', function(newType, oldType) {
            if ($scope.creative.type === 'vastInlineHtmlWrapper') {
                $scope.checkVASTAdTagURI($scope.creative.VASTAdTagURI);
            }

        }, true);


      $scope.$watch('creative.type', function(newType, oldType) {
          console.log('Change type to ' + newType + ' from ' + oldType + ' loaded: ' + $scope.loadedCreativeType);
        $scope.fetchCreativeTypes().then(function(creativeTypes) {
          $scope.creativeProperties = $scope.getProperties(creativeTypes,newType);
            $scope.imageNote = null;
            $scope.videoNote = null;
            var isChanged = newType !== oldType && $scope.loadedCreativeType !== newType;

            //reset loadedCreativeType and extra fields
            if (isChanged) {
                $scope.loadedCreativeType = null;
                delete $scope.creative.interscrollerOptions;
                delete $scope.creative.inscreenOptions;
                delete $scope.creative.sitebarOptions;
                delete $scope.creative.hpaOptions;
            }



            $scope.isInvalidTypesDetected = false;
            console.log(newType);
            if (newType !== null) {
                $scope.validTypePairs.forEach(function (value) {
                    var campaign_types = ["Dev/Staging"].concat(value.campaign_type);
                    var creative_types = ["rawJS", "rawHTML", "trackingOnly"].concat(value.creative_type);
                    console.log($scope.campaign.type, campaign_types, creative_types);

                    if (campaign_types.indexOf($scope.campaign.type) !== -1) {
                        console.log("ok", $scope.campaign.type);
                        let matched = false;
                        creative_types.forEach(function (creative_type_pattern) {
                            if (newType.match(creative_type_pattern)) {
                                console.log(newType, creative_type_pattern);
                                matched = true;
                                return;
                            }
                        })
                        if (!matched) {
                            $scope.isInvalidTypesDetected = true;
                            console.log("isInvalidTypesDetected", $scope.isInvalidTypesDetected);
                        }
                    }
                });
            }



            console.log('Change type to after load: ' + newType + " changed: " + (isChanged  ? "true" : "false") );
            switch (newType) {
                case 'Switch-In-Classic':
                    $scope.imageNote = 'JPG or PNG - 420x240 - 80KB max.';
                    $scope.videoNote = null;
                    break;
                case 'Switch-In-Classic-to-Video':
                    $scope.imageNote = 'JPG or PNG - 420x240 - 80KB max.';
                    $scope.videoNote = 'MP4 - H.264 codec - 1280x720 - 25MB max.';
                    break;
                case 'Switch-In-XXL':
                    $scope.imageNote = 'JPG or PNG - 1280x720 - 160KB max.';
                    $scope.videoNote = null;
                    break;
                case 'Switch-In-XXL-to-Video':
                    $scope.imageNote = 'JPG or PNG - 1280x720 - 160KB max.';
                    $scope.videoNote = 'MP4 - H.264 codec - 1280x720 - 25MB max.';
                    break;
                case 'Switch-In-Animation':
                case 'Switch-In-Animation-to-Microsite':
                    $scope.imageNote = 'GIF - 1280x720 - 700KB max.';
                    break;
                case 'Switch-In-Animation-to-Video':
                    $scope.imageNote = 'GIF - 1280x720 - 700KB max.';
                    $scope.videoNote = 'MP4 - H.264 codec - 1280x720 - 25MB max.';
                    break;
                case 'JS Interscroller Type A':
                    if (isChanged) {
                        $scope.creative.interscrollerOptions = Object.assign({}, InterscrollerTypeAService.getDefaultOptions());
                        console.log("Load options", $scope.creative.interscrollerOptions);
                        $scope.creative.content = InterscrollerTypeAService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                    }
                    addInterscrollerOptionsWatch();

                    break;
                case 'JS Interscroller Type B':
                    if (isChanged) {
                        $scope.creative.interscrollerOptions = Object.assign({}, InterscrollerTypeBService.getDefaultOptions());
                        console.log("Load options", $scope.creative.interscrollerOptions);
                        $scope.creative.content = InterscrollerTypeBService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                    }
                    addInterscrollerOptionsWatch();
                    break;
                case 'JS Interscroller Type C':
                    if (isChanged) {
                        $scope.creative.interscrollerOptions = Object.assign({}, InterscrollerTypeCService.getDefaultOptions());
                        console.log("Load options", $scope.creative.interscrollerOptions);
                        $scope.creative.content = InterscrollerTypeCService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                    }
                    addInterscrollerOptionsWatch();
                    break;
                case 'JS Interscroller Type E':
                    if (isChanged) {
                        $scope.creative.interscrollerOptions = Object.assign({}, InterscrollerTypeEService.getDefaultOptions());
                        console.log("Load options", $scope.creative.interscrollerOptions);
                        $scope.creative.content = InterscrollerTypeEService.generateContent($scope, InterscrollerCommonService, $scope.creative.interscrollerOptions);
                    }
                    addInterscrollerOptionsWatch();

                    break;

                case 'JS Interscroller Type Z':
                    if (isChanged) {
                        $scope.creative.content = "";
                        delete $scope.creative.interscrollerOptions;
                    }
                    break;
                case 'JS InScreen Type A':
                    if (isChanged) {
                        $scope.creative.inscreenOptions = Object.assign({}, InscreenTypeAService.getDefaultOptions());
                        console.log("Load options", $scope.creative.inscreenOptions);
                        $scope.creative.content = InscreenTypeAService.generateContent($scope, InscreenCommonService, $scope.creative.inscreenOptions);
                    }
                    addInscreenOptionsWatch();

                    break;
                case 'JS Sitebar Type A':
                    if (isChanged) {
                        $scope.creative.sitebarOptions = Object.assign({}, SitebarTypeAService.getDefaultOptions());
                        console.log("Load options", $scope.creative.sitebarOptions);
                        $scope.creative.content = SitebarTypeAService.generateContent($scope, SitebarCommonService, $scope.creative.sitebarOptions);
                    }
                    addSitebarOptionsWatch();

							break;
						case 'InImage Type A':
							if (isChanged) {
								$scope.creative.inimageOptions = Object.assign({}, InImageTypeAService.getDefaultOptions());
								console.log("Load options", $scope.creative.inimageOptions);
							}
							break;
						case 'InImage Type B':
							if (isChanged) {
								$scope.creative.inimageOptions = Object.assign({}, InImageTypeBService.getDefaultOptions());
								console.log("Load options", $scope.creative.inimageOptions);
							}
							break;
						case 'InImage Type C':
							if (isChanged) {
								$scope.creative.inimageOptions = Object.assign({}, InImageTypeCService.getDefaultOptions());
								console.log("Load options", $scope.creative.inimageOptions);
							}
							break;
						case 'InImage Type D':
							if (isChanged) {
								$scope.creative.inimageOptions = Object.assign({}, InImageTypeDService.getDefaultOptions());
								console.log("Load options", $scope.creative.inimageOptions);
							}
							break;
						case 'InImage Type X':
							if (isChanged) {
								$scope.creative.inimageOptions = Object.assign({}, InImageTypeXService.getDefaultOptions());
								console.log("Load options", $scope.creative.inimageOptions);
							}
							break;
						case 'native':
							//select all layouts and IDs for new creatives
							if (!$scope.creative.id) {
								$scope.creative.native_layouts = [];
								$scope.creative.native_adunit_ids = [];
								$scope.options.native.Layouts.map(function(option) {
									$scope.creative.native_layouts.push(option.value);
								});
								$scope.options.native.AdUnitIds.map(function(option) {
									$scope.creative.native_adunit_ids.push(option.value);
								});
							}


                    break;
            }

          if (!$scope.$$phase) {
            $scope.$apply();
          }
        });
      });

      $scope.fetchCreativeTypes = function() {
        if ($scope.options.hasOwnProperty('creativeTypes')) {
          return new Promise(function(resolve) {
            resolve($scope.options.creativeTypes);
          });
        }

        var apiResponse = optionsApi.getCreativeTypes();
        apiResponse.then(
          function(data) {
            $scope.options.creativeTypes = data;
            $scope.fetch();
          },
          function() {
            console.log('could not load creative types');
          }
        );

        return apiResponse;
      };

      optionsApi.getCreativeWeights().then(
        function(data) {
          $scope.options.creativeWeights = data;
        },
        function() {
          console.error('could not load creativeWeights');
        }
      );

      optionsApi.getNativeDicts().then(
        function(data) {
            $scope.options.native = data;
        },
        function() {
            console.error('could not load getNativeDicts');
        }
  );

      // check whether the block should be shown or not according to the given property
      $scope.hasProperty = function(property) {
        return (
          $scope.creativeProperties &&
          $scope.creativeProperties.indexOf(property) > -1
        );
      };

      // get list of properties according to the selected creative template type
      $scope.getProperties = function(creativeTypes, type) {
        for (var i = 0; i < creativeTypes.length; i++) {
          if (type === creativeTypes[i].value) {
            return creativeTypes[i].properties;
          }
        }

        return [];
      };


      // get type name
      $scope.getTypeName = function(type) {
          var creativeTypes = $scope.options.creativeTypes;

          for (var i = 0; i < creativeTypes.length; i++) {
              if (type === creativeTypes[i].value) {
                  return creativeTypes[i].name;
              }
          }

          return type;
      };

      /**
       * check if Creative name is unique per advertiser
       * @return {boolean}
       */
      $scope.isNameUnique = function() {
        if (
          $scope.creativeForm &&
          $scope.creativeForm.hasOwnProperty('creative-name')
        ) {
          return !$scope.creativeForm['creative-name'].$error.unique;
        }

        return true;
      };


        /**
         * check if Creative name is unique per advertiser
         * @return {boolean}
         */
        $scope.adGapIdInvalid = function() {
            if (
                $scope.creativeForm &&
                $scope.creativeForm.hasOwnProperty('adgap_id')
            ) {
                return $scope.creativeForm['adgap_id'].$error.pattern;
            }

            return false;
        };

        $scope.copyToClipboard = function(text) {
            var copyElement = document.createElement("textarea");
            copyElement.style.position = 'fixed';
            copyElement.style.opacity = '0';
            copyElement.textContent = text;
            var body = document.getElementsByTagName('body')[0];
            body.appendChild(copyElement);
            copyElement.select();
            document.execCommand('copy');
            body.removeChild(copyElement);
        }

        $scope.copyRedirectorCodeToClipboard = function () {
            $scope.copyToClipboard($scope.sspx_redirector.code);
            alert("Redirector Code successfully copied to clipboard");
        };
        /**
         * copyUrlToClipboard
         * @param text
         */
        $scope.copyUrlToClipboard = function (url) {
            $scope.copyToClipboard(url);
            alert("Tracking Url successfully copied to clipboard");
        };

        $scope.assetTitle = function(action, index) {
            if (action === "add") {
                if ($scope.creative.assets[1] === undefined) {
                    $scope.creative.assets[1] = [];
                }
                $scope.creative.assets[1].push({
                    required: 0,
                    params: {'text': ''}
                });
            } else {
                $scope.creative.assets[1].splice(index, 1);
            }
        }
        $scope.assetData = function(action, index) {
            if (action === "add") {
                if ($scope.creative.assets[4] === undefined) {
                    $scope.creative.assets[4] = [];
                }
                $scope.creative.assets[4].push({
                    required: 0,
                    params : {'type' : null, 'label' : '', 'value' : ''}
                });
            } else {
                $scope.creative.assets[4].splice(index,1);
            }
        }
        $scope.assetImage = function(action, index) {
            if (action === "add") {
                if ($scope.creative.assets[2] === undefined) {
                    $scope.creative.assets[2] = [];
                }
                $scope.creative.assets[2].push({
                    required: 0,
                    params: {'type' : null, 'image': ''}
                });
            } else {
                $scope.creative.assets[2].splice(index,1);
            }
        }
        $scope.assetVideo = function(action, index) {
            if (action === "add") {
                if ($scope.creative.assets[3] === undefined) {
                    $scope.creative.assets[3] = [];
                }
                $scope.creative.assets[3].push({
                    required: 0,
                    params: {
                        'mime_types' : [],
                        'duration' : 20,
                        'vasttag' : ''
                    }

                });
            } else {
                $scope.creative.assets[3].splice(index,1);
            }
        }


        $scope.fetchAndValidateVASTAdTagUri = function(uri, cb) {
                fetch(uri)
                    .then(response => response.text())
                    .then(str => (new window.DOMParser()).parseFromString(str, "text/xml"))
                    .then(doc => {

                        let mediaFiles = doc.querySelectorAll("MediaFile");
                        let VASTAdTagURI  = doc.querySelectorAll("VASTAdTagURI ");
                        let foundValidUrl = false;
                        mediaFiles.forEach(mediaFile => {
                            //console.log(mediaFile);
                            //console.log(mediaFile.firstChild.wholeText);
                            if (mediaFile.firstChild !== undefined && mediaFile.firstChild.wholeText !== undefined && mediaFile.firstChild.wholeText.includes("https://")) {
                                foundValidUrl = true;
                            }
                        });
                        VASTAdTagURI.forEach(vastadtaguri => {
                            if (vastadtaguri.firstChild !== undefined && vastadtaguri.firstChild.wholeText !== undefined && vastadtaguri.firstChild.wholeText.includes("https://")) {
                                foundValidUrl = true;
                            }
                        });

                        if (foundValidUrl) {
                            cb(true);
                            return;
                        }

                        if (uri.includes("extremereach.io")) {
                            cb("Warning: (extremereach) external wrapper adtags seem to be inactive, broken or missing creative");
                        } else {
                            cb("Notice: (unspecific) external wrapper adtags seem to be inactive, broken or missing creative");
                        }


                    })
                    .catch(error => {
                        console.error(error);
                        cb("Notice: External wrapper adtags could not be checked/confirmed with success; high risk for broken ad or expensive delivery by mistakes!\"");

                    });

        }

        $scope.checkVASTAdTagURI = function (uri) {
            $scope.vastAdTagUriValidation.msg = '';
            if (uri.includes("GDPR")) {
                if (!uri.match(/\${GDPR_CONSENT(_\d+){0,1}}/)) {
                    $scope.vastAdTagUriValidation.msg = 'Warning: GDPR on but GDPR_CONSENT or GDPR_CONSENT_<num> macro missing';
                    return;
                }
            }

            $scope.vastAdTagUriValidation.isLoading = true;
            $scope.fetchAndValidateVASTAdTagUri(uri, msg => {
                $scope.vastAdTagUriValidation.isLoading = false;
                $scope.vastAdTagUriValidation.msg = (msg !== true ? msg : "");
                if (!$scope.$$phase) {
                    $scope.$apply();
                }
            });

        }


        $scope.getPreviewPlacementId  = function (creative) {
            var creativeType = "";
            if (creative && creative.type) {
                creativeType = creative.type;
            }
            if (creativeType.includes('InSkin')) return 399;
            if (creativeType.includes('Sitebar')) return 2341;
            if (creativeType.includes('HPA')) return 2341;
            return 210;
        }

        $scope.generateSSPXRedirectorCode = function () {
            $scope.sspx_redirector.code = '';
            $scope.sspx_redirector.adtype = document.getElementById("sspx_redirector_adtype").value;
            console.log($scope.sspx_redirector);
            creativeApi.generateSSPXRedirectorCode($scope.creative.id, $scope.sspx_redirector.adtype, $scope.sspx_redirector.bidder, $scope.sspx_redirector.deal).then(
                function(data) {
                    if (data.error) {
                        alert(data.error)
                    } else {
                        //document.getElementById("sspxRedirectCode").value = data.code;
                        $scope.sspx_redirector.code = data.code;
                    }
                },
                function() {
                    console.log('could not load redirect code');
                }
            );
        }



    },
  ]);
})(window.angular);

